export default __webpack_public_path__ + "static/media/dawn-to-dusk-bg.c22d2f1b.jpeg";